










































































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { GridLayout, GridItem } from "vue-grid-layout";
import { SaveBIReportDesign, GetBIReportModuleList } from "@/api/biReport";
import sqlSelect from "./sqlSelect.vue";
import itemTable from "./table.vue";
import itemChart from "./chart.vue";
import itemSummary from "./summary.vue";
import { GetSqlTempCreated, GetSqlTempData } from "@/api/systemBasic";
import sqlQuery from './sqlQuery.vue';

/**
 * BI设计页面
 */
@Component({
  components: {
    GridLayout,
    GridItem,
    sqlSelect,
    itemTable,
    itemChart,
    sqlQuery,
    itemSummary
  },
})
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;
  saveLoading = false;
  moduleList: any = [];
  colNum: number = 12;
  sqlSelectShow = false;
  sqlSelectData = {};
  currentIndex: number = -1;
  resizeFlag: number = 0;
  queryList: any = [];// sql查询条件
  queryJson: string = "";// sql查询条件json字符串

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  created() {
    this.getData();
  }

  // 读取当前BI报表的所有模块
  async getData() {
    this.saveLoading = true;
    let res = await GetBIReportModuleList({
      reportNo: this.data.report.reportNo,
    });
    this.saveLoading = false;
    this.moduleList = res.objects;
    this.loadSqlQuerys();
  }

  // 读取所有sql的查询条件，然后合并相同的条件进行显示
  // 两个查询条件相同的判断依据是字段编码是否相同
  async loadSqlQuerys() {
    this.queryList = [];
    if (this.moduleList && this.moduleList.length > 0) {
      this.moduleList.forEach(async (m) => {
        // 读取所有模块的查询条件
        let res = await GetSqlTempCreated({
          SqlName: m.sqlMaintainName,
        });
        if (res.objects.queryList) {
          // 合并查询条件
          res.objects.queryList.forEach(q => {
            let query = this.queryList.find(x => x.title == q.title);
            if (query == null) {
              this.queryList.push(q);
            }
          });
        }
      });
    }
  }

  // 添加模块
  add() {
    this.moduleList.push({
      x: 0,
      y: 12,
      w: 4,
      h: 8,
      i: this.moduleList.length,
      reportNo: this.data.report.reportNo,
      moduleNo: this.guid(),
      sqlMaintainName: "",
      itemType: "",
      itemPosition: "",
      data: [],// 结果集
      loading: false,// 加载圈
    });
  }

  // 移除模块
  remove(index: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要移除此模块吗？",
      onOk: () => {
        this.moduleList.splice(index, 1);
        this.currentIndex = -1;
        this.loadSqlQuerys();
      },
    });
  }

  // 显示设置模块弹窗
  sqlMaintainSelect(index) {
    this.currentIndex = index;
    this.sqlSelectData = {
      moduleInfo: this.moduleList[index],
    }
    this.sqlSelectShow = true;
  }

  // 设置模块完成
  handleSqlSelect(data: any) {
    this.moduleList[this.currentIndex].sqlMaintainName = data.sqlName;
    this.moduleList[this.currentIndex].itemType = data.itemType;
    this.moduleList[this.currentIndex].itemPosition = data.itemPosition;
    this.sqlSelectShow = false;
    this.loadSqlQuerys();
  }

  async save() {
    let payload = {
      ReportNo: this.data.report.reportNo,
      ModuleList: this.moduleList,
    };
    this.saveLoading = true;
    let res = await SaveBIReportDesign(payload);
    this.saveLoading = false;
    if (res.status == 1) {
      this.$emit("input", false);
    }
  }

  resizedEvent(item: any) {
    if (item.itemType == "table") {
      // 重新设置表格高度
      this.resizeFlag = new Date().getTime();
    }
  }

  // 刷新数据
  handleRefreshData(queryJson) {
    console.log(queryJson);
    this.queryJson = queryJson;
    // 多个sql脚本依次读取查询结果
    if (this.moduleList && this.moduleList.length > 0) {
      this.moduleList.forEach(async (m) => {
        let query = {
          QueryJson: this.queryJson,
          SqlName: m.sqlMaintainName,
        };
        m.loading = true;
        let res = await GetSqlTempData(query);
        m.loading = false;
        if (res.objects.jsonText && res.objects.jsonText.length > 0) {
          m.data = JSON.parse(res.objects.jsonText);
        } else {
          m.data = [];
        }
        // 强制刷新，解决数据不更新的问题。
        this.$forceUpdate();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/biReport/design.vue